export const FETCH_SELF_DETAILS = "FETCH_SELF_DETAILS";
export const FETCH_USERS_TO_IMPERSONATE = "FETCH_USERS_TO_IMPERSONATE";
export const SELECT_PROFILE = "SELECT_PROFILE";

// external action types
export const NS_FETCH_SELF_DETAILS = "auth/FETCH_SELF_DETAILS";
export const NS_FETCH_USERS_TO_IMPERSONATE = "auth/FETCH_USERS_TO_IMPERSONATE";
